import { Paper, Radio, Stack, TextInput, Title } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";

import { EncounterAmendmentReason } from "@/encounters/constants/encounter-amendment-reason";

type FormWithAmendmentInfo = {
  encounterAmendmentInfo?: {
    encounterAmendmentInfoReason?: string | { code: string; display: string; system: string };
    encounterAmendmentInfoSpecify?: string;
    encounterAmendmentInfoNotes?: string;
    encounterAmendmentInfoNotifyClient?: boolean;
  };
};

interface AmendmentFormReasonProps<T extends FormWithAmendmentInfo> {
  form: UseFormReturnType<T>;
}

export default function AmendmentFormReason<T extends FormWithAmendmentInfo>({
  form,
}: AmendmentFormReasonProps<T>) {
  const inputProps = form.getInputProps("encounterAmendmentInfo.encounterAmendmentInfoReason");
  const reasonError =
    form.errors?.[`encounterAmendmentInfo.encounterAmendmentInfoReason`] || inputProps.error;

  return (
    <Paper radius="lg" data-testid="encounter-amendment-form">
      <Stack
        justify="space-between"
        pb={{ base: 0, xs: "xs" }}
        mx={{ base: "xs", md: "xl" }}
        pt={{ base: "xs", xs: "md", sm: "lg", md: "xl" }}
      >
        <Title order={3} c="burgundy.9">
          Amendment Info
        </Title>
        <Radio.Group required error={reasonError} label="Reason for amendment" {...inputProps}>
          <Radio
            mt="md"
            color="burgundy.9"
            label="Provider correction of information"
            data-testid="encounter-amendment-reason-provider-correction"
            value={EncounterAmendmentReason.ProviderCorrectionOfInformation}
          />
          <Radio
            mt="md"
            color="burgundy.9"
            label="Client requested change"
            value={EncounterAmendmentReason.ClientRequestedChange}
            data-testid="encounter-amendment-reason-client-requested"
          />
          <Radio
            mt="md"
            label="Other"
            color="burgundy.9"
            value={EncounterAmendmentReason.Other}
            data-testid="encounter-amendment-reason-other"
          />
        </Radio.Group>
        {form.values.encounterAmendmentInfo?.encounterAmendmentInfoReason ===
          EncounterAmendmentReason.Other && (
          <TextInput
            required
            label="Please specify"
            data-testid="encounter-amendment-specify-input"
            {...form.getInputProps("encounterAmendmentInfo.encounterAmendmentInfoSpecify")}
          />
        )}
        <TextInput
          label="Amendment Note"
          data-testid="encounter-amendment-note-input"
          {...form.getInputProps("encounterAmendmentInfo.encounterAmendmentInfoNotes")}
        />
        {/* <Checkbox
          label="Notify client of changes"
          {...form.getInputProps("encounterAmendmentInfo.encounterAmendmentInfoNotifyClient")}
        /> */}
      </Stack>
    </Paper>
  );
}
